<template>
    <div id="NRLGraph" style="background-color: #22293d;"></div>
</template>

<script>
    import Highcharts from 'highcharts';
    import loadHeatmap from 'highcharts/modules/heatmap';

    export default {
        name: "NRL-forecast",
        data: () => ({
            chart: null,
            textColor: "#ffffff",
            bgColor: "#22293d",
            isDarkMode: true,
            NRLData: null
        }),
        watch: {
            '$route.query.style': function() {
                var globv = this;
                globv.checkStyle();
            },
        },
        mounted() {
            var globv = this;
            globv.checkStyle();
        },
        methods: {
            checkStyle: function() {
                var globv = this;
                if (globv.$route.query.style && globv.$route.query.style == "light") {
                    globv.textColor = "#22293d";
                    globv.bgColor = "#F5F9FA";
                    globv.isDarkMode = false;
                }
                else {
                    globv.textColor = "#ffffff";
                    globv.bgColor = "#22293d";
                    globv.isDarkMode = true;
                }

                if (globv.NRLData && !globv.isDarkMode) {
                    globv.createChart(globv.NRLData);
                }
            },
            createChart: function(NRLInfo) {
                var globv = this;
                let NRLData = NRLInfo['data'];

                if (NRLData) {
                    globv.NRLData = NRLData;
                    let data = [];

                    let title = globv.$route.params.operator + " Platforms: Surface Current Speed Forecast (m/s) | Source: NRL";

                    var location = []
                    for (let a in NRLData) {
                        //data.push([NRLData[a]['time'], NRLData[a]['location'], NRLData[a]['speed']]);
                        location.push(NRLData[a]['location'])
                    }
                    var ulocs = location.filter((value, index) => location.indexOf(value) === index)
                    console.log(ulocs)
                    var i = 0
                    for (let l in ulocs) {
                        for (let a in NRLData) {
                            if (NRLData[a]['location'] == ulocs[l]) {
                                data.push([NRLData[a]['time'], i, NRLData[a]['speed']]);
                            }
                        }
                        i = i + 1
                    }

                    //console.log(location)
                    //console.log(data);
                    // let colors = [
                    //     "#800080",
                    //     "#2362BA",
                    //     "#6DDF76",
                    //     "#FFE033",
                    //     "#F79C6A",
                    //     "#ED4553"
                    // ];
                    // let interval = 1 / (colors.length - 1);
                    // let stops = colors.map((val, i) => [i * interval, val]);
                    loadHeatmap(Highcharts);
                    globv.chart = Highcharts.chart('NRLGraph', {
                        chart: {
                            type: 'heatmap',
                            backgroundColor: globv.bgColor
                        },
                        credits: {
                            enabled: false,
                            credits: false
                        },
                        title: {
                            text: title,
                            style: {
                                color: globv.textColor
                            }
                        },
                        xAxis: {
                            type: 'datetime',
                            labels: {
                                style: {
                                    color: globv.textColor,
                                    fontSize: '12'
                                }
                            }
                        },
                        yAxis: {
                            categories: ulocs,
                            labels: {
                                style: {
                                    color: globv.textColor,
                                    fontSize: '12'
                                }
                            }
                        },
                        colorAxis: {
                            format: "{value} m/s",
                            stops: [
                                [0, '#3060cf'],
                                [0.15, '#fffbbc'],
                                [0.25, '#c4463a'],
                                [.55, '#c4463a']
                            ],
                            min: 0,
                            max: 2.5,
                            startOnTick: false,
                            endOnTick: false
                        },
                        series: [{
                            borderWidth: 0,
                            data: data,
                            nullColor: '#EFEFEF',
                            colsize: 24 * 36e5,
                            // tooltip: {
                            //     headerFormat: 'speed<br/>',
                            //     pointFormat: '{point.x:%e %b, %Y} {point.y}:00: <b>{point.value} ℃</b>'
                            // }

                            tooltip: {
                                pointFormatter: function() {
                                    let output = Highcharts.dateFormat('%A, %b %d, %H:%M', this.x) + '<br/>';
                                    output += "Speed: <b>" + this.value.toFixed(3) + " m/s</b><br/>";

                                    return output;
                                }
                            }
                        }]
                    });
                }

            },
            reflow: function() {
                var globv = this;
                if (globv.chart) {
                    globv.chart.reflow();
                }
            },
        }
    }
</script>
